'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pipe = undefined;

var _Pipe = require('./Pipe');

var _Pipe2 = _interopRequireDefault(_Pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pipe = new _Pipe2.default('_root_');

exports.default = pipe;
exports.Pipe = _Pipe2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fsts/lib/pipe/index.js
 ** module id = 787
 ** module chunks = 0
 **/